import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, SlidersHorizontal } from "lucide-react";

// import { RadioGroup } from "@headlessui/react";
import CertificatForm from "./CertificatForm";

export default function LabelSearchForm({
  isOpen,
  toggleOpen,
  handleChange,
  formData,
  searchHandler,
  intialisationHandler,
}) {
  const contentVariants = {
    hidden: { height: 0, opacity: 0 },
    visible: { height: "auto", opacity: 1 },
  };

  return (
    <>
      <div className="bg-white shadow rounded mb-6 overflow-hidden">
        <button
          className="w-full  bg-[#00075e]  text-white flex items-center justify-between px-4 py-3 border-b text-left"
          onClick={toggleOpen}
        >
          <div className=" space-x-2 flex items-center">
            <SlidersHorizontal className=" h-5" />
            <span className="font-semibold text-[0.9rem] md:text-lg">
              Critères de recherche
            </span>
          </div>

          <ChevronDown
            className={`w-6 h-6 text-white transform transition-transform ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </button>

        <AnimatePresence initial={false}>
          {isOpen && (
            <motion.div
              className="p-4  flex flex-col gap-6"
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={contentVariants}
              transition={{ duration: 0.3 }}
            >
              <div>
                <p className="text-sm font-medium text-gray-700 ">
                  Rechercher:
                </p>
              </div>

              <CertificatForm
                searchHandler={searchHandler}
                formData={formData}
                handleChange={handleChange}
                intialisationHandler={intialisationHandler}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
}
